import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export async function getFacebookIntegrations(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  const response = await client.client.get("support/facebook", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}
